import { Avatar } from "@radix-ui/themes";
import React from "react";

interface Props {
  avatarUrl: string  | undefined;
  profileCompletion: number | null; // Value between 0 and 100 representing the profile completion percentage
}

const ProfileProgressBar: React.FC<Props> = ({
  avatarUrl,
  profileCompletion,
}) => {
  const progressBarRadius = 45; // Radius of the circular progress bar
  const progressBarCircumference = 2 * Math.PI * progressBarRadius; // Circumference of the circular progress bar
  let progressBarOffset = 0;
  if (profileCompletion) {
    progressBarOffset =
      progressBarCircumference -
      (profileCompletion / 100) * progressBarCircumference;
  }

  return (
    <div className="relative w-20 h-20 flex items-center justify-center">
      {/* SVG Progress Circle */}
      <svg
        className="absolute"
        viewBox="0 0 100 100"
        width="80"
        height="80"
      >
        <circle
          r={progressBarRadius}
          cx="50"
          cy="50"
          fill="transparent"
          stroke="#e5e7eb"
          strokeWidth="4"
        />
        <circle
          r={progressBarRadius}
          cx="50"
          cy="50"
          fill="transparent"
          stroke="#3B0764"
          strokeWidth="4"
          strokeDasharray={progressBarCircumference}
          strokeDashoffset={progressBarOffset}
          transform="rotate(-90 50 50)"
        />
      </svg>

      {/* Avatar in center */}
      <div className="w-[66px] h-[66px] rounded-full overflow-hidden z-10">
        <img
          src={avatarUrl}
          alt="Profile"
          className="w-full h-full object-cover rounded-full"
        />
      </div>
    </div>
  );
};

export default ProfileProgressBar;
